import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClinicSkinServiceMasterByClinicId = createAsyncThunk(
  "clinicSkinServiceMaster/getClinicSkinServiceMasterByClinicId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinicSkinServiceMaster/getClinicSkinServiceMasterByClinicId",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const updateClinicSkinServiceDetails = createAsyncThunk(
  "clinicSkinServiceMaster/updateClinicSkinServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicSkinServiceMaster/updateClinicSkinServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteClinicSkinServiceDetails = createAsyncThunk(
  "clinicSkinServiceMaster/deleteClinicSkinServiceDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinicSkinServiceMaster/deleteClinicSkinServiceDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  // Appointment Skin.jsx uses this
  clinicSkinServiceMasterByClinicId: [],
  // Clinic Skin Service page uses this
  clinicSkinServiceMasterList: [],
  // isLoading: false,
  updateClinicSkinServiceDetailsSuccessMessage: null,
  updateClinicSkinServiceDetailsErrorMessage: null,
  deleteClinicSkinServiceDetailsSuccessMessage: null,
  deleteClinicSkinServiceDetailsErrorMessage: null,
  searchClinicSkinServiceMasterErrorMessage: null,
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  hasMore: false,
};
const clinicSkinServiceMasterSlice = createSlice({
  name: "clinicSkinServiceMaster",
  initialState,
  reducers: {
    resetUpdateClinicSkinServiceDetailsMessage: (state) => {
      state.updateClinicSkinServiceDetailsSuccessMessage = null
      state.updateClinicSkinServiceDetailsErrorMessage = null
    },
    resetDeleteClinicSkinServiceDetailsMessage: (state) => {
      state.deleteClinicSkinServiceDetailsSuccessMessage = null
      state.deleteClinicSkinServiceDetailsErrorMessage = null
    },
    resetSearchClinicSkinServiceMasterMessage: (state) => {
      state.searchClinicSkinServiceMasterErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClinicSkinServiceMasterByClinicId.pending, (state) => {
          state.loading = true;
        })
      .addCase(getClinicSkinServiceMasterByClinicId.fulfilled, (state, action) => {
          state.loading = false;
          if (!action.payload.success) {
            // Appointment data
            state.clinicSkinServiceMasterByClinicId = [];
            // Clinic page data
            state.clinicSkinServiceMasterList = [];
            state.currentPage = 1;
            state.totalPages = 1;
            state.totalCount = 0;
            state.hasMore = false;
            state.searchClinicSkinServiceMasterErrorMessage =
              action.payload.result?.message || "No data found";
            return;
          }
          const result = action.payload.result;
          state.clinicSkinServiceMasterByClinicId = [
            {services: result.list || [], },];
          state.clinicSkinServiceMasterList = result.list || [];
          // Pagination
          state.currentPage = Number(result.currentPage) || 1;
          state.totalPages = Number(result.totalPages) || 1;
          state.totalCount = Number(result.totalRecords) || 0;
          state.hasMore = result.hasMore ?? false;
          state.searchClinicSkinServiceMasterErrorMessage = null;
        },
      )
      .addCase(getClinicSkinServiceMasterByClinicId.rejected, (state, action) => {
          state.loading = false;
          state.clinicSkinServiceMasterByClinicId = [];
          state.clinicSkinServiceMasterList = [];
          state.searchClinicSkinServiceMasterErrorMessage = action.payload || "Something went wrong";
        },
      )
      .addCase(updateClinicSkinServiceDetails.pending,(state) => {
          state.Loading = true;
          state.updateClinicSkinServiceDetailsSuccessMessage = null;
          state.updateClinicSkinServiceDetailsErrorMessage = null;
        },
      )
      .addCase(updateClinicSkinServiceDetails.fulfilled,(state, action) => {
          state.Loading = false;
          if (action.payload.success === true) {
            state.updateClinicSkinServiceDetailsSuccessMessage =
              action.payload.result.message;
          } else {
            state.updateClinicSkinServiceDetailsErrorMessage =
              action.payload.result.message;
          }
        },
      )
      .addCase(updateClinicSkinServiceDetails.rejected,(state, action) => {
          state.Loading = false;
          state.updateClinicSkinServiceDetailsErrorMessage =
            action.payload || "Something went wrong";
        },
      )
      .addCase(deleteClinicSkinServiceDetails.pending,(state) => {
          state.Loading = true;
          state.deleteClinicSkinServiceDetailsSuccessMessage = null;
          state.deleteClinicSkinServiceDetailsErrorMessage = null;
        },
      )
      .addCase(deleteClinicSkinServiceDetails.fulfilled, (state, action) => {
          state.Loading = false;
          if (action.payload.success === true) {
            state.deleteClinicSkinServiceDetailsSuccessMessage =
              action.payload.result.message;
        } else {
          state.deleteClinicSkinServiceDetailsErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClinicSkinServiceDetails.rejected, (state, action) => {
        state.Loading = false;
        state.deleteClinicSkinServiceDetailsErrorMessage = action.payload || "Something went wrong"; 
      })
  },
});

export const {
  resetUpdateClinicSkinServiceDetailsMessage,
  resetDeleteClinicSkinServiceDetailsMessage,
  resetSearchClinicSkinServiceMasterMessage,
} = clinicSkinServiceMasterSlice.actions;

export default clinicSkinServiceMasterSlice.reducer;
